// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__kjHUY"};